import { Typography } from '@mui/material';
import { forwardRef } from 'react';

import { Project } from '@work4all/models/lib/Classes/Project.entity';

export interface ProjectTextProps extends React.HTMLAttributes<HTMLDivElement> {
  project: Project;
  variant?: 'caption' | 'body2';
}

export const ProjectText = forwardRef<HTMLDivElement, ProjectTextProps>(
  function ProjectText(props, ref) {
    const { project, variant = 'body2', ...otherProps } = props;

    if (!project) {
      return null;
    }

    const renderContent = () => {
      return (
        <>
          <Typography component="span" variant={variant} color="text.tertiary">
            {project.number}
            {project.number && project.name ? ' | ' : ''}
          </Typography>
          <Typography component="span" variant={variant}>
            {project.name}
          </Typography>
        </>
      );
    };

    return (
      <Typography
        ref={ref}
        component="div"
        variant={variant}
        noWrap
        {...otherProps}
      >
        {renderContent()}
      </Typography>
    );
  }
);

export function projectAsString(project: Project): string {
  if (!project) return '';

  return project.name;
}
